{
    "poolsMicroserviceURL": "https://vuecapacityst1.azurefd.net/v1/",
    "capacityMicroserviceURL": "https://vuecapacityst1.azurefd.net/v1/",
    "pageTitleSuffix": ""
}